export default {"src":"/_next/static/media/bq.c309d8e7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};